import { observer } from "@legendapp/state/react";
import { NavLink } from "react-router-dom";
import { ReactComponent as EnterIcon } from "../../assets/icons/enter.svg";
import { state$ } from "../../state";
import NavItems from "../../state/staticItems";
import "./Home.page.scss";

const HomePage = observer(() => {
    const isFullWidthState = state$.settings.isFullWidthState.get();

    return (
        <div className={`content content--homepage animated-max-width ${isFullWidthState ? 'container-fluid' : 'container'}`}>
            <div className="row">
                <div className="col d-flex">
                    <div className="content__wrapper">
                        <h2 className="content__title content__entry-title">
                            Public Inquiry: Planning applications at Dominus Stratford
                        </h2>

                        <ul className="home-cards list d-flex f-wrap">
                            {
                                NavItems.filter(item => item.name !== 'Home').map((item) => (
                                    <li key={item.path} className="home-cards__item">
                                        <NavLink to={item.path} className="home-cards__link d-flex">
                                            <span className="home-cards__description">
                                                {item.name}
                                            </span>

                                            <EnterIcon />
                                        </NavLink>
                                    </li>
                                ))
                            }
                        </ul>

                        {/* <p className="home-cards--notes">
                            If you wish to download the entire contents of this library please email <br /><strong>CMS IT Service Desk.</strong>
                        </p> */}
                    </div>

                </div>
            </div>
        </div>
    )


}
)

export default HomePage;
